import { isArrayNotEmpty } from 'utilities/JSUtil'
import * as actionTypes from './actionTypes'

/**
 * Execute a method that returns a promise asynchronously and return the response
 * 
 * @param {*} method the method to be executed
 * @param {*} data the data to be passed to the method
 */
export const asyncMethod = (formName, action, data) => {

    return dispatch => {
        callMethod(actionTypes.retrieveAsnycMethod(formName, action), data)
            .then(response => {
                dispatch(handleHttpResponse(action, response))
            })
            .catch(error => {
                dispatch(handleHttpErrorResponse(action, error))
            })
    }
}

const handleHttpResponse = (action, response) => {
    return {
        httpAction: action,
        data: response,
        type: actionTypes.HANDLE_HTTP_RESPONSE,
        isLockError: false,
        isAuthError: false,
        isSystemError: false
    }
}

const handleHttpErrorResponse = (action, error) => {
    let isLockError = false
    let isAuthError = false
    let isSystemError = false

    if (error.messages) {
        if (error.messages[0].code === 'UPDATE_NOT_ALLOWED') {
            isLockError = true
        } else if (error.messages[0].code === 'UNAUTHORIZED') {
            isAuthError = true
        } else if (error.messages[0].code === 'SYSTEM_ERROR') {
            isSystemError = true
        }
    }

    return {
        httpAction: action,
        data: isArrayNotEmpty(error.messages) ? {
            message: error.messages[0].code,
            description: error.messages[0].message
        } : {
            message: 'ERROR',
            description: 'Error'
        },
        isLockError: isLockError,
        isAuthError: isAuthError,
        isSystemError: isSystemError,
        type: actionTypes.HANDLE_HTTP_ERROR_RESPONSE
    }
}

export const handleUserLogin = data => {
    return {
        type: actionTypes.HANDLE_USER_LOGIN,
        data: data,
        isLockError: false,
        isAuthError: false,
        isSystemError: false
    }
}

const callMethod = (method, data) => {
    return method(data)
        .then(response => {
            return response
        }).catch(error => {
            throw error
        })
}